var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlayButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 37,
    viewBox: "0 0 31 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.714844 1.0803C0.714844 0.294415 1.57968 -0.184354 2.24569 0.232827L29.6471 17.3967C30.2726 17.7885 30.2726 18.6998 29.6471 19.0916L2.24569 36.2555C1.57968 36.6727 0.714844 36.1939 0.714844 35.408V1.0803Z",
    fill: "#005B7A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.e0cb7b062e1c2cf2889abc3e3bfb2f82.svg";
export { ForwardRef as ReactComponent };